export default "__VITE_ASSET__3eM8DaXY__"